<template>
  <div
    v-if="!loading && articles.length"
    class="pb-24 relative desk:layout-container"
  >
    <a id="ProductArticles" />
    <h3 id="ProductArticlesHeading" class="type-headline-xl mb-24 mobOnly:px-12">{{ $t('productPage.info.guidesAndInspiration') }}</h3>

    <!-- content -->
    <div class="transition-opacity duration-300 opacity-100 desk:layout-container mobOnly:mt-24">
      <client-only>
        <swiper-container
          role="region"
          aria-labelledby="ProductArticlesHeading"
          :a11y-prev-slide-message="$t('wcag.arialabel.previousSlide')"
          :a11y-next-slide-message="$t('wcag.arialabel.nextSlide')"
          :space-between="uiStore.isMobile ? 8 : 16"
          :slides-per-view="uiStore.isMobile ? 1.15 : 3"
          :slides-offset-before="uiStore.isMobile ? 12 : 0"
          :slides-offset-after="uiStore.isMobile ? 24 : 0"
          :navigation="articles.length > 3"
          :pagination="{
            clickable: true,
            dynamicBullets: true,
          }"
          class="mobOnly:px-24"
        >
          <swiper-slide
            v-for="article in articles"
            :key="article.uuid"
          >
            <nuxt-link
              :to="`/${article.full_slug}`"
              class="group"
            >
              <div class="relative overflow-hidden">
                <nuxt-img
                  :src="article.content.summaryImage.filename"
                  preset="standard"
                  loading="lazy"
                  sizes="mob375:50vw mob390:50vw mob414:50vw desk:273px"
                  class="w-full object-cover aspect-wide group-hover:scale-110 transition-transform duration-300"
                  :alt="article.content.summaryImage.alt || ''"
                />
              </div>
              <div class="pr-12 pt-16">
                <div
                  v-if="article.content.summaryCategories"
                  class="type-tagline-xs mb-8"
                >
                  {{ article.content.summaryCategories }}
                </div>
                <div class="type-headline-md">
                  {{ article.content.summaryTitle }}
                </div>
              </div>
            </nuxt-link>
          </swiper-slide>
        </swiper-container>
      </client-only>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ProductModel } from '#models/product';
import { useGlobalContentStore } from '~/store/globalContent';
import { StoryBlokArticlePage } from '#constants/types/storyblok';
import { useUiStore } from '~/store/ui';
const storyblokApi = useStoryblokApi();
const globalContent = useGlobalContentStore();

const uiStore = useUiStore();

const props = defineProps<{
  productItem: ProductModel;
}>();

const loading = ref(true);

onMounted(()=> {
  setTimeout(() => loadArticles(), 50);
});

const articles = ref<StoryBlokArticlePage[]>([]);

const loadArticles = async() => {
  const filters = props.productItem.categories.map((m) => {
    return { 'category.category.id': { in: m.code } };
  }) as any[];

  /*if (props.productItem.brand?.code) {
    filters.push({ 'brand.brand.id': { in: props.productItem.brand.code } });
  }*/

  const { data } = await storyblokApi.get('cdn/stories/', {
    version: useRuntimeConfig().public.storyblokStoriesVersion as 'draft' | 'published',
    starts_with: globalContent.articlesFolder,
    content_type: 'ArticlePage',
    excluding_fields: 'body',
    per_page: 20,
    filter_query: {
      __or: filters,
    },
  });
  if (data) {
    articles.value = data.stories;
    loading.value = false;
  }
};

</script>